<script>
    import {router} from "../lib/Router/Router.svelte";
    import R, {LOADER} from "../lib/requests";
    import user from "../stores/user";
    // import app from "../stores/app";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {randomColor} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import Breadcrumb from "../components/Breadcrumb.svelte";
    import ColorControl from "../components/controls/ColorControl.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";
    import ProjectClients from "./ProjectClients.svelte";
    import InputGroupColor from "../components/controls/InputGroupColor.svelte";
    import PriceControl from "../components/controls/PriceControl.svelte";
    import ClientSelectControl from "../clients/ClientSelectControl.svelte";
    import ClientControl from "../components/controls/ClientControl.svelte";
    import AssignedUsers from "../components/controls/AssignedUsers.svelte";

    export let project_id = 0;
    export let editCallback;

    let breadcrumb = [
        {name: 'Projects', link: `/app/project`}
    ];
    let project = null;
    let projectName = '';

    const initialize = () => {
        if (project_id) {
            load();
        } else {
            project = {
                id: 0,
                client_id: null,
                name: '',
                color: randomColor(),
                min_price: null,
                price_per_hour: null,
                round_up_price: 0,
                notes: '',
                users: [],
            };
            projectName = "Δημιουργία Project";
        }
    };

    const load = () => {

        const onSuccess = result => {
            project = result;
            projectName = result.name;
        }

        const onFailure = err => {
        };

        R.handle(R.project.details, project_id, onSuccess, onFailure, LOADER.PAGE);
    };

    const save = () => {

        const onSuccess = result => {
            project = result;
            editCallback(project);
            Notifier.showMessage("Το project ενημερώθηκε");
        }

        const onFailure = err => {
            Alert.warning("Project", err.message);
        };

        let action = project.id > 0 ? 'edit' : 'create';
        R.handle(R.project[action], project, onSuccess, onFailure, LOADER.POPUP);
    };


    const onSelectClient = ({detail}) => {
        project.client_id = detail ? detail.id : null;
        project.client = detail;
    }


    initialize();
</script>

<Breadcrumb {breadcrumb}/>
{#if project}
    <PageHeader title="{ projectName }"/>

    <div class="row">
        <div class="col-lg-6">
            <div class="panel panel-default">
                <div class="panel-heading">
                    Στοιχεία Project
                </div>
                <div class="panel-body panel-pad">
                    <div class="form-group">
                        <h5>Όνομα</h5>
                        <div class="input-group">
                            <input type="text" class="form-control" id="name" bind:value="{ project.name }"
                                   required>
                            <InputGroupColor bind:value="{ project.color }"/>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-md-6">

                            <div class="form-group">
                                <label class="fw-semibold">Πελάτης</label>
                                <ClientControl clientId={project.client_id} client={project.client}
                                               on:select={onSelectClient}/>
                            </div>
                            <label class="fw-semibold">Χρέωση εργασίας</label>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label>ανά ώρα</label>
                                        <PriceControl bind:value="{ project.price_per_hour }"/>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label>ελάχιστη</label>
                                        <PriceControl bind:value="{ project.min_price }"/>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <Checkbox label="Στρογγυλοποίηση χρέωσης"
                                          bind:checked="{ project.round_up_price }"
                                          disabled="{ !project.price_per_hour }"/>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="form-group">
                                <label class="fw-semibold">Χρήστες</label>
                                <AssignedUsers bind:users={project.users}/>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Σημειώσεις</label>
                        <textarea class="form-control" bind:value="{ project.notes }"></textarea>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col">

                        </div>
                        <div class="col text-end">
                            <button class="btn btn-primary" on:click={save}>ΕΝΗΜΕΡΩΣΗ</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/if}
